import { connect } from "react-redux";
import { Dispatch } from "redux";
import { KeyboardType } from "../../constants/keyboardTypes";
import { postLoginInformationToServer } from "../../sagas/RequestSagas/actions";
import { ApplicationState } from "../../store";
import { connectInputToKeyboard, setupEnterFunction, disconnectKeyboard } from "../../store/Keyboard/actions";
import { getFocusedElementId } from "../../store/Keyboard/selectors";
import { getHasUserAlreadySubmittedInfo, getIsLoginValid, getMyleCommunicationErrorStatus } from "../../store/Login/selectors";
import { ClinicLogin } from "./ClinicLoginPage.component";
import { IClinicLoginMapDispatchProps, IClinicLoginMapStateProps } from "./Types";
import { getLoadingSpinnerVisibilityState } from "../../store/LoadingSpinner/selectors";

const mapStateToProps = (state: ApplicationState): IClinicLoginMapStateProps => {
    return {
        alreadySubmitted: getHasUserAlreadySubmittedInfo(state.login),
        isConnecting: getLoadingSpinnerVisibilityState(state.loadingSpinner),
        isValidLogin: getIsLoginValid(state.login),
        focusedElementId: getFocusedElementId(state.keyboard),
        isHavingIssuesCommunicatingWithMyle: getMyleCommunicationErrorStatus(state.login),
        loginErrorCode: state.login.loginErrorCode
    }
};

const mapDispatchToProps = (dispatch: Dispatch): IClinicLoginMapDispatchProps => ({
    onLogin: (userName: string, password: string, authenticationCode: string) => {
        if (userName && password) {
            dispatch(postLoginInformationToServer(userName, password, authenticationCode));
        }
    },

    connectKeyboard: (func: (value: any) => void, val: string, elementId: string, mask: string = "") => {
        dispatch(connectInputToKeyboard(func, val, mask, elementId, KeyboardType.STANDARD));
    },

    setupEnterFunction: (func: () => void) => {
        dispatch(setupEnterFunction(func));
    },

    disconnectKeyboard: () => dispatch(disconnectKeyboard())
});

export default connect<IClinicLoginMapStateProps, IClinicLoginMapDispatchProps, void>(mapStateToProps, mapDispatchToProps)(ClinicLogin);


// WEBPACK FOOTER //
// ./src/components/ClinicLoginPage/ClinicLoginPage.container.ts